import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import React from 'react';

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: 20,
  },
};

const LoadingIndicator = ({ size, thickness }) => (
  <div style={styles.container}>
    <CircularProgress
      // color='#88AD33'
      size={size}
      thickness={thickness}
    />
  </div>
);

LoadingIndicator.propTypes = {
  size: PropTypes.number,
  thickness: PropTypes.number,
};

LoadingIndicator.defaultProps = {
  size: 32,
  thickness: 4,
};

export default LoadingIndicator;
